import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DataContainer from 'Components/UI/DataContainer';
import { useMeetingContext } from 'Context/MeetingContext';
import { useRefreshMissionControLiveEmail } from 'Hooks/useRefreshEvent';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

import PreviousEmailsView from './View';
import useMissionControl from '../../useMissionControl';

const styles = theme => ({
  container: {}, // This style is only applied to the DataContainer
  root: {
    padding: theme.spacing(2),
  },
});

const PreviousEmailsContainer = ({
  className,
  classes,
}) => {
  const {
    meetingLoadingError,
    meetingResource,
    refreshMeetingResource,
  } = useMeetingContext();
  const { noMeetings } = useMissionControl();
  const { householdResource } = useSimpleHousehold();

  useRefreshMissionControLiveEmail(() => {
    refreshMeetingResource();
  }, [meetingResource]);


  return !noMeetings && (
    <DataContainer
      className={classes.container}
      component={PreviousEmailsView}
      componentProps={{
        className: classNames(classes.root, className),
        householdResource,
        meetingResource,
      }}
      loading={!meetingResource}
      loadingError={meetingLoadingError}
    />
  );
};

PreviousEmailsContainer.defaultProps = {
  className: '',
};

PreviousEmailsContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PreviousEmailsContainer);
